import cjquery from 'jquery';
import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import language from '../../../../../assets/languages/language';
import ValidateSaveReportIcon from '../../../../Common/ValidateSaveReportIcon';
import FD from '../../../../RestAPI/fetchData';
import App_data from '../../../../config/App_data';
import { renderHTMLContent } from '../../../../../common/function';
import ViewQuestion from '../../../../../Components-2025/QuestionBank/ViewQuestion';
import { messages } from '../../../../../common/messages';

/* eslint-disable*/
class Frm1Beginquiz extends Component {
  constructor(props) {
    super(props);
    const initialTimerStopFromStorage = localStorage.getItem('timer_stop');
    const initialTimerStop =
      initialTimerStopFromStorage !== null ? JSON.parse(initialTimerStopFromStorage) : false;

    this.state = {
      successAlert: false,
      token: '',
      idname: '',
      quiz_id: this.props.params.quiz_id,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      all_question_id: [],
      question_length: 0,
      timer_value: '',
      include_timer: '',
      user_time_value: '',
      first_question_id: '',
      display_question: {},
      save_text: `${language.LC().SAVE_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: initialTimerStop
        ? 'pause_btn icon-control-play'
        : 'pause_btn icon-control-pause',
      count: 0,
      ValidToken: false,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count_end_message: '',
      timer_stop: initialTimerStop,
      timer_tag: `${language.LC().STOP}`,
      timer_display: 'card-block',
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      already_answered_status: '',
      selectedmenufrm: 'frm',
      display_loader: 'show_block',
      level: '1',
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
    };
    this.timer = null;
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  isTimerFeatureEnabled = () => {
    const { include_timer, timer_value } = this.state;
    return !!include_timer || (timer_value && parseInt(timer_value, 10) > 0);
  };

  manageTimerForQuestion = (isQuestionAnswered) => {
    if (this.timer) clearInterval(this.timer);

    const timerShouldRun =
      this.isTimerFeatureEnabled() && this.state.count > 0 && !isQuestionAnswered;

    if (timerShouldRun) {
      this.timer = setInterval(this.tick.bind(this), 1000);
      this.setState({ timer_stop: false, timerstopbtn: 'pause_btn icon-control-pause' });
      localStorage.setItem('timer_stop', JSON.stringify(false));
    } else {
      this.setState({ timer_stop: true, timerstopbtn: 'pause_btn icon-control-play' });
      localStorage.setItem('timer_stop', JSON.stringify(true));
    }
  };

  tick() {
    const { timer_stop, count, token, idname, quiz_id, count_end_message } = this.state;
    if (timer_stop && this.timer) {
      clearInterval(this.timer);
      return;
    }

    if (count > 0) {
      const count_value = count - 1;
      this.setState({ count: count_value });

      if (!timer_stop) {
        const insert_time = {
          token,
          idname,
          quiz_id,
          user_time_value: count_value,
        };
        FD.callAPI(`${App_data.backend_api}/frm_quizes/insertTimer`, insert_time);
      }
    } else {
      clearInterval(this.timer);
      if (!count_end_message) {
        this.setState({
          count_end_message: language.LC().TIME_UP || messages.TIME_UP,
          timer_stop: true,
          timerstopbtn: 'pause_btn icon-control-play',
        });
        localStorage.setItem('timer_stop', JSON.stringify(true));
      }
    }
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    if (parseInt(this.state.offset) === 0) {
      this.setState({ previ_block: 'card hide_block' });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState(
        {
          idname: storage_session['idname'],
          token: storage_session['token'],
        },
        () => {
          const data = {
            idname: this.state.idname,
            token: this.state.token,
            quiz_id: this.state.quiz_id,
          };
          FD.callAPI(`${App_data.backend_api}/frm_quizes/getQuize`, data).then((resp) => {
            if (resp.success) {
              var retun_all_question = JSON.stringify(resp.singlequiz);
              var all_questions_from_api = JSON.parse(JSON.parse(retun_all_question)).all_questions;
              var question_id_array = [];
              for (var i = 0; i < resp.questions_count; i++) {
                question_id_array.push(all_questions_from_api[i]);
              }

              var api_timer_value = resp.timer_value;
              var user_timer_remaining = resp.user_time_value;

              let count_start_value =
                user_timer_remaining !== undefined &&
                user_timer_remaining !== null &&
                parseInt(user_timer_remaining, 10) > 0
                  ? parseInt(user_timer_remaining, 10)
                  : api_timer_value
                    ? parseInt(api_timer_value, 10)
                    : 0;

              this.setState({
                level: resp.level,
                user_time_value: user_timer_remaining,
                count: count_start_value,
                all_question_id: question_id_array,
                question_length: question_id_array.length,
                timer_value: api_timer_value,
                include_timer: resp.include_timer,
                first_question_id: question_id_array[this.state.offset],
              });

              if (question_id_array.length - 1 === this.state.offset) {
                this.setState({ next_block: 'card hide_block' });
              }

              const first_question_id_for_fetch = question_id_array[this.state.offset];
              if (!first_question_id_for_fetch) {
                this.setState({
                  display_loader: 'hide_block',
                  already_answered_status: messages.QUESTION_NOT_FOUND,
                });
                return;
              }

              var question_data_payload = {
                token: this.state.token,
                idname: this.state.idname,
                question_id: first_question_id_for_fetch,
                quiz_id: this.state.quiz_id,
              };

              FD.callAPI(
                `${App_data.backend_api}/frm_question_bank/getQuestionsbyid`,
                question_data_payload,
              ).then((qResp) => {
                if (!qResp.success) {
                  this.setState({
                    display_loader: 'hide_block',
                    already_answered_status: messages.QUESTION_DETAILS_ERROR,
                  });
                  return;
                }

                // Redirect to quiz path
                this.context.router.push({
                  pathname: `/frm/1/beginquiz/${this.state.quiz_id}/${this.state.offset}`,
                });

                const data_check = {
                  token: this.state.token,
                  idname: this.state.idname,
                  quiz_id: this.state.quiz_id,
                  question_id: first_question_id_for_fetch,
                };

                // Check if already answered
                FD.callAPI(`${App_data.backend_api}/frm_quizes/checkAnswered`, data_check).then(
                  (resp_inner) => {
                    this.setState({ already_answered_status: resp_inner.message });

                    const currentQuestion = qResp.questionsbyid;
                    const selectedChoice =
                      currentQuestion['frm_answer_quizzes.selected_choice'] || '';
                    const rightAnswer = currentQuestion['frm_answer_quizzes.answer'] || '';
                    const answerStatus = currentQuestion['frm_answer_quizzes.id'] || '';
                    const correctChoice = currentQuestion.right_choice || '';

                    let showAnswer = false;
                    let selected = '';

                    if (selectedChoice) {
                      selected = selectedChoice;
                      showAnswer = true;
                    } else if (answerStatus) {
                      if (rightAnswer === 1) {
                        selected = correctChoice;
                        showAnswer = true;
                      } else if (!rightAnswer) {
                        const choices = Object.keys(currentQuestion).filter(
                          (key) => key.startsWith('choice') && key !== correctChoice,
                        );
                        selected = choices.length > 0 ? choices[0] : '';
                        showAnswer = true;
                      }
                    }

                    // Build choices styling
                    const choiceBoxes = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
                    const updatedChoices = {};
                    choiceBoxes.forEach((choiceKey) => {
                      updatedChoices[choiceKey] =
                        selected === choiceKey ? 'answer_box clicked_box' : 'answer_box';
                    });

                    this.setState(
                      {
                        display_question: currentQuestion,
                        choice: selected,
                        clicked: !!selected,
                        validated: !!selected,
                        result_block: showAnswer ? 'card show_block' : 'card hide_block',
                        text_color:
                          selected === correctChoice
                            ? 'card-header text_success'
                            : 'card-header text_failure',
                        result: selected === correctChoice ? messages.CORRECT : messages.INCORRECT,
                        display_loader: 'hide_block',
                        ...updatedChoices,
                      },
                      () => {
                        this.manageTimerForQuestion(!!selected);
                      },
                    );

                    // Get bookmarked state
                    const paramsFav = {
                      token: this.state.token,
                      quiz_id: this.state.quiz_id,
                      question_id: first_question_id_for_fetch,
                      idname: this.state.idname,
                    };

                    FD.callAPI(
                      `${App_data.backend_api}/frm_question_bank/getFavQuestions`,
                      paramsFav,
                    ).then((response) => {
                      if (response.success) {
                        this.setState({
                          bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                          bookmarkColor: 'rgb(54, 141, 84)',
                          save_text: `${language.LC().Question_Saved}`,
                        });
                      }
                    });

                    // Fetch flashcards
                    const paramsFlash = {
                      token: this.state.token,
                      idname: this.state.idname,
                      question_id: first_question_id_for_fetch,
                      quiz_id: this.state.quiz_id,
                    };
                    this.fetchFlashCardsInternal(paramsFlash);
                  },
                );
              });
            } else {
              this.setState({
                display_loader: 'hide_block',
                already_answered_status: messages.QUIZ_DATA_FETCH_ERROR,
              });
            }
          });
        },
      );
    } else {
      this.setState({
        display_loader: 'hide_block',
        already_answered_status: messages.USER_SESSION_NOT_FOUND,
      });
    }
  }

  fetchFlashCardsInternal = (params) => {
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFlashCards`, params).then(
      (response) => {
        let flash_cards_jsx;
        if (response.success) {
          this.setState({ ValidToken: true });
          if (response.flash_cards && response.flash_cards.length > 0) {
            this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
            flash_cards_jsx = response.flash_cards.map((items) => (
              <li key={items.id}>
                <div className=''>
                  <ul className='icon_list'>
                    <li>
                      <a className='pointer_class' onClick={() => this._editFlash(items)}>
                        <i className='fa fa-pencil' />
                      </a>
                    </li>
                    <li>
                      <a className='pointer_class' onClick={() => this._deleteFlash(items)}>
                        <i className='fa fa-close' />
                      </a>
                    </li>
                  </ul>
                  <div className={this.state.flash_class}>
                    <h4 />
                    <p>{items.flash_card}</p>
                  </div>
                </div>
              </li>
            ));
          } else {
            this.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
            flash_cards_jsx = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          }
        } else {
          this.setState({ ValidToken: false, flash_form: 'col-sm-12 col-md-12 display_block' });
          flash_cards_jsx = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        }
        this.setState({ flash_data: flash_cards_jsx });
      },
    );
  };

  getAnswer = (choiceArray) => {
    const { clicked, timer_stop } = this.state;
    if (clicked) return;
    const selectedChoice = choiceArray[0];
    this.setState({ choice: selectedChoice });
    if (this.isTimerFeatureEnabled() && !timer_stop) {
      clearInterval(this.timer);
      this.setState({
        timer_stop: true,
        timerstopbtn: 'pause_btn icon-control-play',
      });
      localStorage.setItem('timer_stop', JSON.stringify(true));
    }
    const choices = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
    const updatedChoices = {};

    choices.forEach((choice) => {
      updatedChoices[choice] = selectedChoice === choice ? 'answer_box clicked_box' : 'answer_box';
    });

    this.setState(updatedChoices);
  };

  validateAnswer = () => {
    const {
      choice,
      display_question,
      validated,
      token,
      idname,
      quiz_id,
      all_question_id,
      offset,
      level,
      clicked,
      timer_stop,
    } = this.state;
    if (choice && !clicked) {
      this.setState({ clicked: true });
      if (this.isTimerFeatureEnabled() && !timer_stop) {
        clearInterval(this.timer);
        this.setState({
          timer_stop: true,
          timerstopbtn: 'pause_btn icon-control-play',
        });
        localStorage.setItem('timer_stop', JSON.stringify(true));
      }
      const isCorrect = choice === display_question.right_choice;
      this.setState({
        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
        result: isCorrect ? messages.CORRECT : messages.INCORRECT,
        result_block: 'card show_block',
      });
      if (!validated) {
        const right_answer = isCorrect ? 1 : 0;
        const answerQuizData = {
          token,
          idname,
          quiz_id,
          question_id: all_question_id[offset],
          answer: right_answer,
          selectedChoice: choice,
        };
        FD.callAPI(`${App_data.backend_api}/frm_quizes/answerQuiz`, answerQuizData).then((resp) => {
          if (resp.success) {
            const saveStatsData = {
              token,
              idname,
              question_id: all_question_id[offset],
              right_answer,
              time_done: this.state.count,
              level,
            };
            FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveStats`, saveStatsData).then(
              (statResp) => {
                if (statResp.success) {
                  this.setState({ validated: true });
                }
              },
            );
          }
        });
      }
    }
  };

  loadQuestionData = (questionIndex) => {
    const { all_question_id, quiz_id, token, idname, question_length } = this.state;
    this.setState({
      display_loader: 'show_block',
      validated: false,
      clicked: false,
      choice: '',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      offset: questionIndex,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      count_end_message: '',
    });
    if (questionIndex === 0) this.setState({ previ_block: 'card hide_block' });
    else this.setState({ previ_block: '' });
    if (questionIndex === question_length - 1) this.setState({ next_block: 'card hide_block' });
    else this.setState({ next_block: '' });
    const questionIdToLoad = all_question_id[questionIndex];
    if (!questionIdToLoad) {
      this.setState({
        display_loader: 'hide_block',
        already_answered_status: 'Error: Question not found.',
      });
      return;
    }
    const data = { token, idname, question_id: questionIdToLoad, quiz_id: quiz_id };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getQuestionsbyid`, data).then((resp) => {
      if (resp.success) {
        const currentQuestion = resp.questionsbyid;
        const dataCheck = { token, idname, quiz_id, question_id: questionIdToLoad };
        FD.callAPI(`${App_data.backend_api}/frm_quizes/checkAnswered`, dataCheck).then(
          (respInner) => {
            const selectedChoice =
              respInner.question_recived && respInner.question_recived.selected_choice
                ? respInner.question_recived.selected_choice
                : currentQuestion['frm_answer_quizzes.selected_choice'] || '';
            const rightAnswer =
              respInner.question_recived && respInner.question_recived.answer !== undefined
                ? respInner.question_recived.answer
                : currentQuestion['frm_answer_quizzes.answer'] || '';
            const answerStatus =
              respInner.question_recived && respInner.question_recived.id
                ? respInner.question_recived.id
                : currentQuestion['frm_answer_quizzes.id'] || '';
            const correctChoice = currentQuestion.right_choice || '';
            let showAnswer = false;
            let selected = '';
            if (selectedChoice) {
              selected = selectedChoice;
              showAnswer = true;
            } else if (answerStatus) {
              if (rightAnswer === 1) {
                selected = correctChoice;
                showAnswer = true;
              } else if (!rightAnswer) {
                const choices = Object.keys(currentQuestion).filter(
                  (key) => key.startsWith('choice') && key !== correctChoice,
                );
                selected = choices.length > 0 ? choices[0] : '';
                showAnswer = true;
              }
            }
            const choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
            const updatedChoices = {};

            choiceKeys.forEach((choiceKey) => {
              updatedChoices[choiceKey] =
                selected === choiceKey ? 'answer_box clicked_box' : 'answer_box';
            });

            this.setState({
              display_question: currentQuestion,
              choice: selected,
              clicked: !!selected,
              validated: !!selected,
              result_block: showAnswer ? 'card show_block' : 'card hide_block',
              text_color:
                selected === correctChoice
                  ? 'card-header text_success'
                  : 'card-header text_failure',
              result: selected === correctChoice ? messages.CORRECT : messages.INCORRECT,
              display_loader: 'hide_block',
              ...updatedChoices,
            });
            this.manageTimerForQuestion(!!selected);
            const paramsFav = { token, quiz_id, question_id: questionIdToLoad, idname };
            FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFavQuestions`, paramsFav).then(
              (favResp) => {
                if (favResp.success) {
                  this.setState({
                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                    bookmarkColor: 'rgb(54, 141, 84)',
                    save_text: `${language.LC().Question_Saved}`,
                  });
                } else {
                  this.setState({
                    bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
                    bookmarkColor: '',
                    save_text: `${language.LC().SAVE_QUESTION}`,
                  });
                }
              },
            );
            const paramsFlash = { token, idname, question_id: questionIdToLoad, quiz_id };
            this.fetchFlashCardsInternal(paramsFlash);
          },
        );
      } else {
        this.setState({
          display_loader: 'hide_block',
          already_answered_status: 'Failed to load question.',
        });
      }
    });
  };

  getNext = () => {
    const { offset, question_length } = this.state;
    if (offset < question_length - 1) {
      this.loadQuestionData(offset + 1);
    }
  };

  getPrevious = () => {
    const { offset } = this.state;
    if (offset > 0) {
      this.loadQuestionData(offset - 1);
    }
  };

  saveQuestion = (item, e) => {
    const { token, idname, quiz_id, level, bookmarkCSS } = this.state;
    const apiEndpoint =
      bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark'
        ? '/frm_question_bank/unsaveQuestion'
        : '/frm_question_bank/saveQuestion';
    const data = { token, idname, question_id: item.id, quiz_id, level };
    FD.callAPI(`${App_data.backend_api}${apiEndpoint}`, data).then((resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          bookmarkCSS: apiEndpoint.includes('unsave')
            ? 'fa fa-bookmark-o mark-action-btn-bookmark'
            : 'fa fa-bookmark mark-action-btn-bookmark',
          bookmarkColor: apiEndpoint.includes('unsave') ? '' : 'rgb(54, 141, 84)',
          save_text: apiEndpoint.includes('unsave')
            ? `${language.LC().SAVE_QUESTION}`
            : `${language.LC().Question_Saved}`,
        });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  _reportQuestion = (item, e) => {
    const { token, idname, quiz_id } = this.state;
    const commentInput = document.getElementById('comment');
    const comment = commentInput ? commentInput.value : '';
    const data = { token, idname, question_id: item.id, comment, quiz_id };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/reportQuestion`, data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true, successAlert: true });
        if (commentInput) commentInput.value = '';
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  onClose = (e) => {
    this.setState({ report_block: 'card hide_block', successAlert: false });
  };
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };
  _getToggleComment = (item, e) => {
    if (this.refs['comment_toggle_div']) cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };
  _getToggleFlash = (item, e) => {
    if (this.refs['flash_toggle_div']) cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  _saveFlashCard = (item, e) => {
    const flashCardInput = document.getElementById('flash_card');
    if (!flashCardInput || flashCardInput.value === '') return;
    var flash_card = flashCardInput.value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
      quiz_id: this.state.quiz_id,
      level: this.state.level,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveFlashCard`, data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        flashCardInput.value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          quiz_id: this.state.quiz_id,
        };
        this.fetchFlashCardsInternal(params);
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  _editFlash = (item, e) => {
    this.setState({ flash_form: 'col-md-12 display_block' });
    const flashCardInput = document.getElementById('flash_card');
    if (flashCardInput) flashCardInput.value = item.flash_card;
  };

  _deleteFlash = (item, e) => {
    var data = { token: this.state.token, idname: this.state.idname, flash_card_id: item.id };
    FD.callAPI(`${App_data.backend_api}/frm_quizes/deleteFlashCard`, data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true, flash_form: 'col-md-12 display_block' });
        const flashCardInput = document.getElementById('flash_card');
        if (flashCardInput) flashCardInput.value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: this.state.display_question.id,
          quiz_id: this.state.quiz_id,
        };
        this.fetchFlashCardsInternal(params);
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  _timer_funct = () => {
    const { timer_stop, clicked, count, count_end_message, choice } = this.state;
    if (!this.isTimerFeatureEnabled() || clicked || (count <= 0 && !!count_end_message)) return;
    const newTimerStopState = !timer_stop;
    localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
    this.setState({
      timer_stop: newTimerStopState,
      timerstopbtn: newTimerStopState
        ? 'pause_btn icon-control-play'
        : 'pause_btn icon-control-pause',
    });
    if (newTimerStopState) {
      clearInterval(this.timer);
    } else {
      if (count > 0 && !choice && !clicked) {
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 1000);
      } else {
        this.setState({ timer_stop: true, timerstopbtn: 'pause_btn icon-control-play' });
        localStorage.setItem('timer_stop', JSON.stringify(true));
        if (this.timer) clearInterval(this.timer);
      }
    }
  };

  _getSummary = () => {
    this.context.router.push({
      pathname: `/frm/1/beforestart/${this.state.quiz_id}/${this.state.selectedmenufrm}/${'abondon'}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        status_send: 'abondon',
        selectedMenu: this.state.selectedmenufrm,
      },
    });
  };

  render() {
    const {
      display_question,
      count,
      clicked,
      choice,
      timer_stop,
      timerstopbtn,
      count_end_message,
      question_length,
      offset,
      previ_block,
      next_block,
      result_block,
      text_color,
      result,
      display_loader,
      already_answered_status,
      save_text,
      bookmarkCSS,
      bookmarkColor,
      flash_data,
      flash_form,
      report_block,
      successAlert,
      ValidToken,
      quiz_id,
      selectedmenufrm,
    } = this.state;
    let questions = display_question || {};

    let count_temp_var = count;
    let display_time = '0 sec';
    if (typeof count_temp_var === 'number' && count_temp_var >= 0) {
      if (count_temp_var < 60) display_time = count_temp_var + ' sec';
      else display_time = `${Math.floor(count_temp_var / 60)} min ${count_temp_var % 60} sec`;
    }

    const isValidateDisabled = clicked || !choice;
    const isTimerButtonDisabled =
      !this.isTimerFeatureEnabled() || (count <= 0 && !!count_end_message) || clicked;

    let dataContent = '';
    if (question_length > 0 && offset < question_length && Object.keys(questions).length > 0) {
      dataContent = (
        <div>
          <div className='card font-lusitana'>
            <div className='card-header'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                className='margin_right_20'
                width='30'
                alt=''
              />
              {language.LC().Q} {parseInt(offset) + 1}{' '}
              {renderHTMLContent(questions.name, 'span', '', { contentEditable: false })}
              <div className='float-right text-right'>
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + previ_block}
                  onClick={this.getPrevious}
                  role='button'
                  tabIndex={0}
                  onKeyPress={this.getPrevious}
                  aria-label='Previous question'
                />
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + next_block}
                  onClick={this.getNext}
                  role='button'
                  tabIndex={0}
                  onKeyPress={this.getNext}
                  aria-label='Next question'
                />
              </div>
            </div>
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <ViewQuestion
                    {...questions}
                    {...this.props}
                    setAnswer={this.getAnswer}
                    showAnswer={clicked}
                    correctChoice={questions.right_choice}
                    selectedChoice={choice}
                  >
                    <div className='col-md-12 mt-2'>
                      <div className='row align-items-center'>
                        <ValidateSaveReportIcon
                          isQue={true}
                          clicked={isValidateDisabled}
                          _getResult={this.validateAnswer}
                          _saveQuestion={() => this.saveQuestion(questions)}
                          _displayReportForm={() => this._displayReportForm(questions)}
                          all_questions={questions}
                          save_text={save_text}
                          bookmarkCSS={bookmarkCSS}
                          bookmarkColor={bookmarkColor}
                          showResult={clicked || !choice}
                        />
                      </div>
                    </div>
                  </ViewQuestion>
                </div>
                <div className='col-sm-3'>
                  {this.isTimerFeatureEnabled() && (
                    <div>
                      <div className='timer_outer'>
                        <i className='fa fa-clock-o' />
                        {!count_end_message && <span className='timer_box'>{display_time}</span>}
                      </div>
                      {!(count <= 0 && !!count_end_message) && (
                        <span className={'quiz_timer_btn ' + this.state.timer_display}>
                          <button
                            type='button'
                            aria-label={this.state.timer_stop ? 'Resume timer' : 'Pause timer'}
                            className={timerstopbtn}
                            onClick={this._timer_funct}
                            disabled={isTimerButtonDisabled}
                          />
                        </span>
                      )}
                      {count_end_message && (
                        <p className='text-danger'>
                          {renderHTMLContent(count_end_message, 'div', '', {
                            contentEditable: 'false',
                          })}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {clicked && result_block === 'card show_block' && (
            <div className={`${result_block} font-lusitana font-16px`}>
              <div className={text_color}>{result}</div>
              <div className='card-block'>
                {renderHTMLContent(questions.answer, 'div', '', { contentEditable: false })}
              </div>
            </div>
          )}

          <div className={report_block}>
            <div className='card-header'>{language.LC().REPORT}</div>
            {!successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-md-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong>{language.LC().COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-md-12 margin_bottom_10'>
                    <textarea
                      id='comment'
                      name='comment'
                      rows='6'
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class'
                      onClick={() => this._reportQuestion(questions)}
                    >
                      {' '}
                      {language.LC().REPORT}{' '}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={() => this._hideReportForm(questions)}
                    >
                      {' '}
                      {language.LC().CANCEL}{' '}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class min-vw-120'
                      onClick={this.onClose}
                    >
                      {' '}
                      {language.LC().CLOSE}{' '}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    } else if (display_loader === 'hide_block') {
      dataContent = <div>{already_answered_status || messages.QUIZ_FINISHED}</div>;
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-sm-8 margin_bottom_20'>
              <h1 className='section_head'>Quiz ID : {quiz_id}</h1>
            </div>
            <div className='col-sm-4 margin_bottom_20 text-sm-right'>
              <button className='btn btn-primary pointer_class' onClick={this._getSummary}>
                {language.LC().BACK_TO_SUMMARY}
              </button>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 margin_bottom_20'>{dataContent}</div>
          </div>
        </div>
        <div className={'loader_box ' + display_loader}>
          <div className='sk-circle'>
            {[...Array(12)].map((_, i) => (
              <div key={i} className={`sk-circle${i + 1} sk-child`} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { tooltipOpen: false };
  }
  toggle() {
    this.setState({ tooltipOpen: !this.state.tooltipOpen });
  }
  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

export default Frm1Beginquiz;



// WEBPACK FOOTER //
// ./src/views/FRM/Frm1Quizzes/part-1/Frm1Beginquiz/Frm1Beginquiz.js